import { httpsCallable } from 'firebase/functions'
import { functions, auth } from '@/config/firebase'

/**
 * Test scheduled notifications by scheduling one for 10 seconds from now
 */
export async function testScheduledNotification(): Promise<void> {
  try {
    const currentUser = auth.currentUser
    if (!currentUser) {
      console.error('❌ No authenticated user found')
      return
    }

    console.log('🧪 Testing scheduled notification...')
    
    // Schedule a notification for 10 seconds from now
    const scheduleNotification = httpsCallable(functions, 'scheduleNotification')
    const scheduledTime = new Date(Date.now() + 10000) // 10 seconds from now
    
    const result = await scheduleNotification({
      userId: currentUser.uid,
      notification: {
        title: '🧪 Scheduled Test',
        body: 'This is a test scheduled notification',
        scheduledTime: scheduledTime.toISOString(),
        data: {
          test: 'scheduled-test',
          debug: 'true',
          scheduledAt: new Date().toISOString(),
          scheduledFor: scheduledTime.toISOString()
        }
      }
    })

    console.log('✅ Scheduled notification created:', result.data)
    console.log(`⏰ Notification will be sent at: ${scheduledTime.toLocaleTimeString()}`)
    
  } catch (error) {
    console.error('❌ Failed to schedule test notification:', error)
  }
}

/**
 * Test immediate notification to compare with scheduled
 */
export async function testImmediateNotification(): Promise<void> {
  try {
    const currentUser = auth.currentUser
    if (!currentUser) {
      console.error('❌ No authenticated user found')
      return
    }

    console.log('🧪 Testing immediate notification...')
    
    const sendNotification = httpsCallable(functions, 'sendNotification')
    const result = await sendNotification({
      userId: currentUser.uid,
      notification: {
        title: '⚡ Immediate Test',
        body: 'This is an immediate notification test',
        data: {
          test: 'immediate-test',
          debug: 'true',
          timestamp: Date.now().toString()
        }
      }
    })

    console.log('✅ Immediate notification sent:', result.data)
    
  } catch (error) {
    console.error('❌ Failed to send immediate notification:', error)
  }
}

/**
 * Run both tests to compare immediate vs scheduled notifications
 */
export async function runNotificationTests(): Promise<void> {
  console.log('🧪 Starting notification tests...')
  
  // Test immediate notification first
  await testImmediateNotification()
  
  // Wait a moment
  await new Promise(resolve => setTimeout(resolve, 2000))
  
  // Test scheduled notification
  await testScheduledNotification()
  
  console.log('✅ Notification tests completed!')
  console.log('📱 Check your browser for notifications in the next 10-15 seconds')
} 